'use client'
import { useThemeConfig } from "@/components/ui/active-theme"
import { useI18n } from "@/contexts/lang-context"
import { useSettings } from "@/contexts/settings-context"
import { Toaster } from "sonner"

export function ToasterWithLang() {
  const { isRtl } = useI18n()
  const { toastPosition } = useSettings()
  const { activeTheme } = useThemeConfig()
  return (
    <Toaster richColors closeButton dir={isRtl ? 'rtl' : 'ltr'} swipeDirections={['left', 'right']} position={toastPosition} theme={activeTheme} />
  )
}